import { IWykrojnikRow } from "../IWykrojnikRow";
import { IOferta } from "./IOferta";
import { Licz } from "./Log";

export class cost_api {

    public static get_wykrojniki_z_kosztem:string = "/api/cost/get_wykrojniki_z_kosztem"
    public static get_wykrojniki_z_kosztem_detailed:string = "/api/cost/get_wykrojniki_z_kosztem_detailed"
    public static get_oferta:string = "/api/cost/get_oferta"
    public static get_oferta_saved:string = "/api/cost/get_oferta_saved"
    public static get_oferta_by_id:string = "/api/cost/get_oferta_by_id"
    public static save_oferta:string = "/api/cost/save_oferta"
    public static get_oferty_arch_ids = "/api/cost/get_oferty_arch_ids"

    public static zlecenia_kontrolne_rezerwuj:string = "/api/cost/zlecenia_kontrolne_rezerwuj"
    public static zlecenia_kontrolne_update:string = "/api/cost/zlecenia_kontrolne_update"
    public static zlecenia_kontrolne_przelicz_all:string = "/api/cost/zlecenia_kontrolne_przelicz_all"

}

export interface IKosztRobSur {
   
    koszt_rob:number;
    min_koszt_rob?: number;
    koszt_sur:number;
    czy_artwork:number;

    mb?:number;
    czas?:number
    
    //dbg?:any;
    licz:Licz|undefined;
    cena_min_za_naklad:Licz|undefined;
    predkosc_druku: number | undefined;
}

export class KosztRobSur implements IKosztRobSur {
   
    koszt_rob:number=0;
    min_koszt_rob?: number=0;
    koszt_sur:number=0;
    czy_artwork:number=0;

    mb?:number=0;
    czas?:number=0;
    
    //dbg?:any={}
    licz:Licz|undefined = undefined;
    cena_min_za_naklad:Licz|undefined=undefined;
    predkosc_druku: number | undefined = undefined;
}

export interface IWykrojnikKoszt {

   
    
    koszt_przezbr:IKosztRobSur
    koszt_zmiany:IKosztRobSur
    koszt_1K:IKosztRobSur


    koszt_nakladu:number
    min_koszt_rob:number
    mb_nakladu:number;

    faktor_mb: number;
    faktor_czasu_przezbrojenia:number;
    faktor_czasu_zmiany:number;
    faktor_czasu_druku:number;

}


export interface IWykrojnikiCostSvc {

    get_wykrojniki_z_kosztem(tree_id:any):Promise<IWykrojnikRow[]|undefined>;
    get_oferta(tree_id:any):Promise<IOferta|undefined>;
    zlecenia_kontrolne_przelicz_all():Promise<number|undefined>;
}
    